import React from 'react';
import { getLogoData } from './getLogoData';
import { SvgIcon } from '../../../core/icons';

const BrandLogo = ({ modelInfo, showBackArrow = false }) => {
  const logo = getLogoData(modelInfo);
  return (
    <a href={modelInfo.homepageUrl} className="fallback-global-nav__logo">
      <div className="fallback-global-nav__image-container">
        {showBackArrow ? <SvgIcon name="back" /> : null}
        <img
          className="fallback-global-nav__image"
          alt={modelInfo.brand}
          src={logo?.logoUrl}
        />
      </div>
    </a>
  );
};

export default BrandLogo;
